export const isPortrait = (screenOrientation: string): boolean => {
  return (
    screenOrientation === 'PORTRAIT' ||
    screenOrientation === 'PORTRAIT-UPSIDEDOWN'
  );
};
